/**
 * Navigation registry (CF-0026). Features register entries; the shell renders sections whose spoke is
 * installed (from /me/ `spokes`), entitled, and whose permission the user holds.
 */
import type { SvgIconComponent } from "@mui/icons-material";

export type NavEntry = {
  label: string;
  to: string;
  permission?: string | string[];
  icon?: SvgIconComponent;
  flag?: string;
};

export type NavSection = {
  key: string;
  spoke: string;
  title: string;
  icon?: SvgIconComponent;
  order: number;
  entries: NavEntry[];
};

const sections = new Map<string, NavSection>();

export function registerNavSection(section: Omit<NavSection, "entries"> & { entries?: NavEntry[] }) {
  const existing = sections.get(section.key);
  if (existing) {
    existing.entries.push(...(section.entries ?? []));
    return existing;
  }
  const created: NavSection = { ...section, entries: [...(section.entries ?? [])] };
  sections.set(section.key, created);
  return created;
}

export function registerNavEntry(sectionKey: string, entry: NavEntry) {
  const section = sections.get(sectionKey);
  if (!section) throw new Error(`Unknown nav section ${sectionKey}`);
  section.entries.push(entry);
}

export function navSections(): NavSection[] {
  return [...sections.values()].sort((a, b) => a.order - b.order);
}
